import React, { useEffect, useState } from "react";
import AuthService from "../../../class/services/AuthService";
import UserService from "../../../class/User/UserService";
import UserServices from "../../../class/User_copy/UserService";

import Language from "../box_button/language_button";

import ModalMenuButton from "../box_button/ModalMenuButton";
import { useTranslation } from "react-i18next";
import { useWebSocket } from '../../../context/WebSocketContext';


const ModalMenu = ({
    selection_header_external,
    setselection_header_external,
    isOpen,
    onClose,
    selectedCurrency,
    handleNavigationChange,
    setLang,
    setIsUserCashBlocked,
    withdrawSection,
}) => {
    const { t } = useTranslation();
    const [balance, setBalance] = useState(null);
    const [loading, setLoading] = useState(true);
    const { disconnect } = useWebSocket();

    // Отримуємо баланс при відкритті модального вікна
    useEffect(() => {
        if (isOpen) {
            const fetchBalance = async () => {
                try {
                    const userId = AuthService.getCustom("user_id");
                    const currency = AuthService.getCustom("currency") || "BRL";
                    const balanceData = await UserServices.getbalance(
                        userId,
                        currency,
                        2,
                    );
                    setBalance(balanceData.params?.balance);
                } catch (error) {
                    console.error(`${t("Error_fetching_balance")}:`, error);
                } finally {
                    setLoading(false);
                }
            };

            fetchBalance();
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            const path = window.location.pathname;
            const lastSegment = path.substring(path.lastIndexOf("/") + 1);
            const validTabs = [
                "bet_history",
                "account_setting",
                "cash_movement",
                "deposit_withdraw",
                "notification" /* , 'promotions' */,
            ];

            if (validTabs.includes(lastSegment)) {
                setselection_header_external(lastSegment);
            }
        }
    }, [isOpen]);

    return (
        <div
            className={`modal fade navigation-menu ${isOpen ? "show" : ""}`}
            id="navmenu"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden={!isOpen}
            style={{
                display: isOpen ? "block" : "none",
                zIndex: 1050, // додавання високого z-index для модалки
            }}
        >
            {/* Темний і розмитий фон */}
            <div
                className="modal-backdrop fade show"
                style={{ backdropFilter: "blur(5px)", zIndex: 0 }}
                onClick={() => {
                    if (typeof onClose === "function") {
                        onClose();
                    }
                }}
            ></div>

            <div
                className="modal-dialog modal-dialog-scrollable"
                role="document"
            >
                <div className="modal-content">
                    {/* Заголовок модального вікна */}
                    <div className="modal-header">
                        <h3 className="name-account">
                            <small>{t("welcome")}</small>
                            <br />
                            <div id="username">
                                {AuthService.getCustom("username")}
                            </div>
                        </h3>
                        <button
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={onClose}
                        ></button>
                    </div>

                    {/* Тіло модального вікна */}
                    <div className="modal-body">
                        <div className="box-account">
                            <div className="balance">
                                {loading ? (
                                    <p>{t("Login")}...</p>
                                ) : (
                                    balance && (
                                        <>
                                            <p>
                                                {t("Saldo")}
                                                <strong>
                                                    {" "}
                                                    {
                                                        selectedCurrency.value
                                                    }{" "}
                                                    {balance.credits}
                                                </strong>
                                            </p>
                                            <p>
                                                {t("Bonus")}
                                                <strong>
                                                    {" "}
                                                    {
                                                        selectedCurrency.value
                                                    }{" "}
                                                    {balance.bonus}
                                                </strong>
                                            </p>
                                            <p>
                                                {t("Total_balance")}
                                                <strong>
                                                    {" "}
                                                    {
                                                        selectedCurrency.value
                                                    }{" "}
                                                    {(
                                                        parseFloat(
                                                            balance.credits,
                                                        ) +
                                                        parseFloat(
                                                            balance.bonus,
                                                        )
                                                    ).toFixed(2)}
                                                </strong>
                                            </p>
                                        </>
                                    )
                                )}
                            </div>
                            <ModalMenuButton
                                handleNavigationChange={(page) => {
                                    if (typeof onClose === "function") {
                                        onClose();
                                    }
                                    handleNavigationChange(page);
                                }}
                                selection_header_external={
                                    selection_header_external
                                }
                                setselection_header_external={
                                    setselection_header_external
                                }
                                withdrawSection={withdrawSection}
                            />
                        </div>
                    </div>

                    {/* Футер модального вікна */}
                    <div className="modal-footer footer-barNav">
                        <div className="btn-socialGroup">
                            <a
                                className="log-out"
                                href="/logout"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsUserCashBlocked(false);
                                    AuthService.clearAll();
                                    window.location.href = "/";
                                    disconnect();
                                }}
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 24.303 24.303"
                                    style={{
                                        enableBackground:
                                            "new 0 0 24.303 24.303",
                                    }}
                                    xmlSpace="preserve"
                                >
                                    <g>
                                        <path d="M10.269,11.298V1.883C10.269,0.844,11.113,0,12.152,0s1.883,0.844,1.883,1.883v9.415c0,1.039-0.844,1.883-1.883,1.883S10.269,12.337,10.269,11.298z M19.616,2.761c-0.61-0.483-1.5-0.377-1.983,0.234c-0.483,0.612-0.378,1.5,0.234,1.984c2.24,1.767,3.524,4.413,3.524,7.261c0,5.094-4.145,9.239-9.238,9.239c-5.094,0-9.239-4.145-9.239-9.239c0-2.847,1.283-5.492,3.521-7.258c0.612-0.483,0.717-1.371,0.234-1.984c-0.483-0.612-1.37-0.716-1.984-0.234C1.764,5.069,0.089,8.523,0.089,12.24c0,6.652,5.412,12.063,12.063,12.063s12.063-5.412,12.063-12.063C24.215,8.521,22.538,5.067,19.616,2.761z"></path>
                                    </g>
                                </svg>
                                {t("Exit")}
                            </a>
                        </div>
                        <Language setLang={setLang} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalMenu;
